import React from 'react';
import { StickyTableData, TableRow as StyledTableRow } from '../../TableRow.styles';
import { Text } from '../../../../../../../../../../../../../../CommonComponents/OPL/Text/Text';

interface Props {
  name: string;
}

export const EstateTableRow = ({ name }: Props) => {
  return (
    <StyledTableRow>
      <StickyTableData columnPosition={0} colSpan={2}>
        <Text fontWeight={600} textAlign="left" fontSize="h6">
          {name}
        </Text>
      </StickyTableData>
    </StyledTableRow>
  );
};
